module.exports = __webpack_public_path__ + "media/images/admin-back-0de93c39.jpg";